"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var SIZES = {
    xxsmall: 14,
    xsmall: 16,
    small: 20,
    medium: 24,
    large: 32,
    xlarge: 48,
    xxlarge: 64,
    xxxlarge: 92,
};
var Button = function (_a) {
    var icon = _a.icon, size = _a.size, className = _a.className, _b = _a.fill, fill = _b === void 0 ? false : _b, _c = _a.weight, weight = _c === void 0 ? 400 : _c, _d = _a.grade, grade = _d === void 0 ? 0 : _d, _e = _a.opticalSize, opticalSize = _e === void 0 ? 24 : _e, onClick = _a.onClick;
    return (react_1.default.createElement("i", { className: (0, classnames_1.default)(className, 'material-symbols-rounded ui-icon'), "aria-hidden": "true", style: {
            fontSize: SIZES[size || 'medium'],
            lineHeight: SIZES[size || 'medium'] + 'px',
            fontVariationSettings: "'FILL' ".concat(fill ? 1 : 0, " , 'wght' ").concat(weight, ", 'GRAD' ").concat(grade, ", 'opsz' ").concat(opticalSize),
        }, onClick: onClick }, icon));
};
exports.default = Button;
